<template>
  <div class="p-thanks-message-point-summary">
    <div class="p-thanks-message-point-summary__meta">
      <span class="date">
        {{ formatDate }}
      </span>
    </div>
    <div class="p-thanks-message-point-summary__unread">
      <TextLabelThanksMessageUnread
        v-if="unreadCount > 0"
        :count="displayUnreadCount"
      />
    </div>
  </div>
</template>
<script lang="ts">
  import { Options, Vue } from "vue-class-component";
  import commons from "@/common/store/modules/commons";
  import TextLabelThanksMessageUnread from "@/common/components/atoms/TextLabelThanksMessageUnread.vue";

  @Options({
    props: {
      giftPoints: {
        type: Number,
        default: 0
      },
      receivedPoints: {
        type: Number,
        default: 0
      },
      date: {
        type: String,
        default: ""
      },
      unreadCount: {
        type: Number,
        default: 0
      }
    },
    components: {
      TextLabelThanksMessageUnread
    }
  })

  export default class ThanksMessagePointSummary extends Vue {
    giftPoints!: number;
    receivedPoints!: number;
    date!: string;
    unreadCount!: number;
    addComma(value: number): string {
      return Number(value).toLocaleString();
    }

    getUnit() {
      if (commons?.OrgPageSpecific?.point_name) {
        return commons?.OrgPageSpecific?.point_name;
      }
      return commons?.unit?.point;
    }

    get displayUnreadCount() {
      return this.unreadCount >= 100
      ? "..."
      : this.unreadCount;
    }

    get formatDate() {
      return this.date;
    }
  }
</script>
<style lang="scss" scoped>
.p-thanks-message-point-summary {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: rem(12);

  @include pc {
    justify-content: flex-end;
  }

  @include sp {
    justify-content: flex-start;
    width: 100%;
  }
}

.date {
  width: rem(60);
  text-align: left;
   font-size: small;
}

.p-thanks-message-point-summary__unread {
  width: rem(24);
  margin-left: auto;

  display: flex;
  justify-content: center;
}

.p-thanks-message-point-summary__meta {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: rem(8);
  min-width: rem(120);
}

</style>